import useStyles from './style'
/*
 With a label the marker is the chip the centers list and the center detail use
 to name each point. Without one it marks a single located address, so it draws
 the usual map pin instead, anchored by its tip on the coordinate.
*/
const MapMarker = ({ lat, lng, text }) => {
  const classes = useStyles()

  if (!text) {
    return (
      <div lat={lat} lng={lng} className={classes.pin}>
        <svg viewBox="0 0 24 24" width="30" height="30">
          <path
            d="M12 1.5c-3.73 0-6.75 3.02-6.75 6.75 0 5.06 6.75 14.25 6.75 14.25s6.75-9.19 6.75-14.25c0-3.73-3.02-6.75-6.75-6.75z"
            fill="#EA4335"
          />
          <circle cx="12" cy="8.25" r="2.6" fill="#AD2A1F" />
        </svg>
      </div>
    )
  }

  return (
    <div lat={lat} lng={lng} className={classes.marker}>
      {text}
    </div>
  )
}

export default MapMarker
